import { createAction, props } from '@ngrx/store';
import { AdditionalInformationModel } from '@shared/data-access/models';

export const getList = createAction(
  '[Additional Information] GET LIST',
  props<{payload:AdditionalInformationModel[]}>()
);
